import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'

import { HealthLimitations } from '@src/routes/members/components/health-limitations/health-limitations'
import { MemberProfile } from '@src/data/member-profile'

import './health-limitations.sass'

@Component({
  computed: {
    memberProfile () {
      return this.$store.state.memberProfile
    }
  }
})
export class ReadonlyHealthLimitations extends HealthLimitations {

  private memberProfile: MemberProfile

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.HEALTH')}`
  }

  renderButton (h: CreateElement) {
    return null
  }

  protected loadLatestHealthLimitations (): any {
    this.healthLimitationsSet = this.memberProfile.healthLimitationsSet
    this.assignHealthLimResponseToData()
    this.loading = false
  }
}
